import React from 'react';
import './view.less';

/**
 * @class CnSmartFormGuide
 * @description 
 */
export default class CnSmartFormGuide extends React.Component {
  static displayName = 'CnSmartFormGuide';

  constructor(props) {
    super(props);
  }

  render() {
    return this.props.children;
  }
}
